module.exports = __webpack_public_path__ + "img/dypitch-2-mobile.f26fd47d.jpg";